module.exports = __webpack_public_path__ + "img/project_bg2.41ecce9b.png";